import React from 'react';
import AdverseCorporateEventExposureComponent from "./AdverseCorporateEventExposureComponent";
import {padCalendar, getStatType} from "../../../util";

function formatAdverseCorporateEvent(adverseCorporateEvents) {
	for (const adverseCorporateEvent of adverseCorporateEvents) {
		adverseCorporateEvent.date = padCalendar(adverseCorporateEvent.date);
		adverseCorporateEvent.statType = getStatType(adverseCorporateEvent.statTypeNum);
		if (adverseCorporateEvent.vFiltersPass === false) {
            adverseCorporateEvent.severe = 'No'
        } else if (adverseCorporateEvent.vFiltersPass === true) {
            adverseCorporateEvent.severe = 'Yes'
        }
		
	}

	return adverseCorporateEvents;
}

const AdverseCorporateEventContainer = (props) => {

	if (!props.adverseCorporateEvent) {
		return <div>Loading</div>
	}

	const data = formatAdverseCorporateEvent(props.adverseCorporateEvent);

	return (
		<React.Fragment>
			<AdverseCorporateEventExposureComponent adverseCorporateEvent={data} isDandO={sessionStorage.getItem('DANDO')} claimTypeId={props.claimTypeId}/>
		</React.Fragment>
	);

};


export default AdverseCorporateEventContainer;


// WEBPACK FOOTER //
// ./src/common/components/AdverseCorporateEventExposure/AdverseCorporateEventExposureContainer.js